import type { RenderComponentProps } from "../../../shared/types";

import * as React from "react";

import { useProductFromProps } from "../../hooks/useProductFromProps";
import { wrapProductAssignmentToLiquidSource } from "../../utils/reviews";
import { SharedShopifyLiquid } from "../SharedShopifyLiquid";

const LooxReviewsWidget: React.FC<RenderComponentProps> = (props) => {
  const product = useProductFromProps(props.component.props, props.context);

  const liquidSourceWidget = `
  <div id="looxReviews" data-product-id="{{product.id}}" class="loox-reviews-default"></div>
  `;

  const liquid = wrapProductAssignmentToLiquidSource({
    product,
    liquidSource: liquidSourceWidget,
    context: props.context,
  });

  return (
    <SharedShopifyLiquid
      component={props.component}
      componentId={props.component.id}
      componentAttributes={props.componentAttributes}
      liquidSource={liquid}
      isLiquidSupported
      title="Loox Reviews"
      placeholderType="reviewFull"
    />
  );
};

export default LooxReviewsWidget;
